import Service, { service } from '@ember/service'
import type Features from 'teacher-ui-client/services/features'

export enum GradeId {
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6,
}

export default class MathseedsPrimeService extends Service {
  @service features!: Features

  get supportedGradeIds() {
    const gradeIds = this.features.isEnabled('tui_ms_prime_grade_three')
      ? [GradeId.Three, GradeId.Four]
      : [GradeId.Four]
    if (this.features.isEnabled('tui_ms_prime_grade_five')) gradeIds.push(GradeId.Five)
    if (this.features.isEnabled('tui_ms_prime_grade_six')) gradeIds.push(GradeId.Six)
    return gradeIds
  }
}

declare module '@ember/service' {
  interface Registry {
    'mathseeds-prime': MathseedsPrimeService
  }
}
